import React from 'react';
import { NavLink } from 'react-router-dom';
import { IoSettingsSharp } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  sideIcon: {
    padding: '0.5rem', // p-2
    borderRadius: '0.25rem',
    display: 'flex', // flex
    flexDirection: 'column', // flex-col
    alignItems: 'center', // items-center
    transition: 'background-color 0.2s ease-in-out', // Smooth hover effect
    zIndex: 10,
    '&:hover': {
      backgroundColor: '#f3f4f6', // hover:bg-gray-100
      Color: '#f3f4f6'
    },
  },
});

const Sidebar = () => {

  const handleLogout = () => {
    sessionStorage.clear();
  
};

const classes = useStyles();
  return (
    <div className="w-20 h-full bg-white shadow-sm d-flex flex-column align-items-center py-5 gap-2 px-2">
    
    <div className='d-flex align-items-center'>
      <NavLink
        to="/retail"
        end
        className={({ isActive }) =>
          `w-full d-flex flex-column p-2 align-items-center text-center rounded ${isActive ? 'bg-warning text-white' : 'hover:bg-light'}`
        }
      >
          <img src='https://cdn0.iconfinder.com/data/icons/shopping-at-store/317/mobile-purchase-payment-search-005-512.png' style={{width:"40px",height:"40px"}}/>
          <span className="fs-6 fw-semibold">Billing</span>
      </NavLink>
      </div>
      
     
        <div className='d-flex align-items-center'>
      <NavLink
        to="/retail/report"
        className={({ isActive }) =>
          `w-full d-flex flex-column align-items-center p-2 text-center rounded ${isActive ? 'bg-warning text-white' : 'hover:bg-light'}`
        }
      >
         <img src='/report.png' style={{width:"30px",height:"30px"}}/>
      
        <span className="fs-6 fw-semibold">Report</span>
      </NavLink>
      </div>
 <div className='d-flex align-items-center'>
        <NavLink
          to="/retail/inventory"
           className={({ isActive }) =>
          `w-full d-flex flex-column align-items-center p-2 text-center rounded ${isActive ? 'bg-warning text-white' : 'hover:bg-light'}`
        }
        >
          <img src='/inventory.png' style={{width:"30px",height:"30px"}}/>
          <span className="fs-6 fw-semibold">Inventory</span>
        </NavLink>
      </div>
      <div className='d-flex align-items-center'>
      <NavLink
        to="/retail/setting"
        className={({ isActive }) =>
          `w-full d-flex flex-column align-items-center p-2 text-center rounded ${isActive ? 'bg-warning text-white' : 'hover:bg-light'}`
        }
      >
        
        <IoSettingsSharp style={{width:"30px",height:"30px" , color:"black"}}/>
        <span className="fs-6 fw-semibold">Setting</span>
      </NavLink>
       </div>
       
      <NavLink
      to="/"
      onClick={handleLogout}
      className={({ isActive }) =>
        `w-full flex flex-col items-center p-2 text-center rounded ${isActive ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'}`
      }
      >
         <MdLogout style={{width:"30px",height:"30px", color:"black"}}/>
         <span className="fs-6 fw-semibold">Logout</span>
      </NavLink>
     
     
    </div>
  );
};

export default Sidebar;
